var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 9.5C5.59415 9.5 5.89414 9.73422 5.97761 10.0681L6.46847 12.0315L8.4319 12.5224C8.76578 12.6059 9 12.9058 9 13.25C9 13.5942 8.76578 13.8941 8.4319 13.9776L6.46847 14.4685L5.97761 16.4319C5.89414 16.7658 5.59415 17 5.25 17C4.90585 17 4.60586 16.7658 4.52239 16.4319L4.03153 14.4685L2.0681 13.9776C1.73422 13.8941 1.5 13.5942 1.5 13.25C1.5 12.9058 1.73422 12.6059 2.0681 12.5224L4.03153 12.0315L4.52239 10.0681C4.60586 9.73422 4.90585 9.5 5.25 9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 1C12.0577 1 12.3343 1.188 12.4474 1.47418L13.745 4.75506L17.0258 6.05256C17.312 6.16574 17.5 6.44225 17.5 6.75C17.5 7.05775 17.312 7.33426 17.0258 7.44744L13.745 8.74494L12.4474 12.0258C12.3343 12.312 12.0577 12.5 11.75 12.5C11.4423 12.5 11.1657 12.312 11.0526 12.0258L9.75505 8.74494L6.47418 7.44744C6.188 7.33426 6 7.05775 6 6.75C6 6.44225 6.188 6.16574 6.47418 6.05256L9.75505 4.75506L11.0526 1.47418C11.1657 1.188 11.4423 1 11.75 1Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.0fc7f43f157a0e40ba78f2a3d11b9ee3.svg";
export { ForwardRef as ReactComponent };